"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const types_1 = require("@framework/types");
exports.validationSchema = (0, yup_1.object)().shape({
    schedule: (0, yup_1.mixed)().oneOf(Object.values(types_1.CronExpression)).required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map